import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Header.css';

const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="Discover the delecious side of health" />
      <h1 className="app__header-h1">The Key To Healthy Food</h1>
      <p className="p__opensans" style={{ margin: '2rem 0' }}>where health meets flavor in every bite! We redefine fast food by offering a delightful menu of nutritious and delicious options that cater to your well-being. </p>
     <a href="#menu"><button type="button" className="custom__button">Explore Menu</button></a>
    </div>

    <div className="app__wrapper_img">
      <img src={images.welcome} alt="header_img" />
    </div>
  </div>
);

export default Header;